import { ESupportedGames } from "MVVM/@types";
import { MatchHistoryGame } from "MVVM/State/matchHistory";
import { TMatch } from "MVVM/Views/MatchHistory/@types";
import { useRecoilValue } from "recoil";
import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { NotVictoryText, VictoryText } from "../../styledComponents";
import { useWindowSize } from "hooks";

export const GameSpecificColumns = ({ match }: { match: TMatch }) => {
  const matchHistoryGame = useRecoilValue(MatchHistoryGame);

  const { width, height } = useWindowSize();

  const collapseToKDA = width && width < 700;

  if (matchHistoryGame === ESupportedGames.CS2) {
    return (
      <>
        {" "}
        <Column style={{ minWidth: 100 }}>
          {match.result === "Win" ? (
            <VictoryText variant="body">{match.score}</VictoryText>
          ) : (
            <NotVictoryText variant="body">{match.score}</NotVictoryText>
          )}
          <Text variant={"text.labelXSmall"} color="chalk">
            {match.gameMode}
          </Text>
        </Column>
        {!collapseToKDA && (
          <>
            <Column>
              <Text variant={"text.labelXSmall"} color={"chalk"}>
                Kills
              </Text>
              <Text variant={"text.labelMedium"} color={"ice"}>
                {match.killCount}
              </Text>
            </Column>
            <Column>
              <Text variant={"text.labelXSmall"} color={"chalk"}>
                Deaths
              </Text>
              <Text variant={"text.labelMedium"} color={"ice"}>
                {match.deathCount}
              </Text>
            </Column>
          </>
        )}
        {collapseToKDA && (
          <Column>
            <Text variant={"text.labelXSmall"} color={"chalk"}>
              K/D
            </Text>
            <Text variant={"text.labelMedium"} color={"ice"}>
              {match.killCount}/{match.deathCount}
            </Text>
          </Column>
        )}
      </>
    );
  }
  if (matchHistoryGame === ESupportedGames.LOL) {
    return (
      <>
        <Column style={{ minWidth: 100 }}>
          {match.result === "Victory" ? (
            <VictoryText variant="body">{match.result}</VictoryText>
          ) : (
            <NotVictoryText variant="body">{match.result}</NotVictoryText>
          )}
          <Text variant={"text.labelXSmall"} color="chalk">
            {match.gameMode}
          </Text>
        </Column>
        <Column>
          <Text variant={"text.labelXSmall"} color={"chalk"}>
            Role
          </Text>
          <Text variant={"text.labelMedium"} color={"ice"}>
            {match.role}
          </Text>
        </Column>
        <Column>
          <Text variant={"text.labelXSmall"} color={"chalk"}>
            K/D/A
          </Text>
          <Text variant={"text.labelMedium"} color={"ice"}>
            {match.killCount}/{match.deathCount}/{match.assistCount}
          </Text>
        </Column>
      </>
    );
  }
  if (matchHistoryGame === ESupportedGames.FORTNITE) {
    return (
      <>
        {" "}
        <Column style={{ minWidth: 100 }}>
          {match.result === "Victory" ? (
            <VictoryText variant="body">{match.result}</VictoryText>
          ) : (
            <NotVictoryText variant="body">{match.result}</NotVictoryText>
          )}
          <Text variant={"text.labelXSmall"} color="chalk">
            {match.gameMode}: {match.placement} / 100
          </Text>
        </Column>
        <Column>
          <Text variant={"text.labelXSmall"} color={"chalk"}>
            Kills
          </Text>
          <Text variant={"text.labelMedium"} color={"ice"}>
            {match.killCount}
          </Text>
        </Column>
        <Column>
          <Text variant={"text.labelXSmall"} color={"chalk"}>
            Knocks
          </Text>
          <Text variant={"text.labelMedium"} color={"ice"}>
            {match.knockdowns}
          </Text>
        </Column>
      </>
    );
  }
  return <></>;
};
const Column = styled(Flex)`
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 6px;
  min-width: 50px;
`;
